export const TRACKER_TYPES = [
  {title: 'Accounts', value: 'account', icon: 'building-2'},
  {title: 'Prospects', value: 'prospect', icon: 'target'},
  {title: 'Competitors', value: 'competitor', icon: 'flag'},
  {title: 'Topics', value: 'topic', icon: 'hash-02-a'}
]